import { useRouter } from 'next/router';
import BannerA from '../components/BannerA';
import BackupSystemSection from '../components/BackupSystemSection';
import FreeGridSection from '../components/FreeGridSection';
import HomeownersSection1 from '../components/HomeownersSection1';
import HomeownersSection2 from '../components/HomeownersSection2';
import HomeownersSection3 from '../components/HomeownersSection3';
import HomeownersSection4 from '../components/HomeownersSection4';
import FooterTcA from '../components/FooterTcA';

export default function StatusItem() {
    const { locale } = useRouter();

    return (
        <>
            <FreeGridSection />
            <BannerA />
            <BackupSystemSection />
            <HomeownersSection1 />
            <HomeownersSection2 />
            <HomeownersSection3 />
            <HomeownersSection4 />
            <FooterTcA />
        </>
    );
}
